module.exports = __webpack_public_path__ + "static/media/minus.ad91e856.png";